import { OreCheckbox, OreHeading, OreInput, OreStack } from '@edenredespana/oreneta'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SignUpTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { SignUpForm } from '@/AutoEnrollment/ui/hooks'
import { handleErrors } from '@/Shared/ui/form'

export const SignUpBasicForm = (): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState, watch, clearErrors, setValue } =
    useFormContext<SignUpForm>()
  const { errors } = handleErrors(formState)

  const watchPassword = watch('password')
  const watchPasswordRepeat = watch('passwordRepeat')
  const watchEmail = watch('email')
  const watchEmail_confirmation = watch('emailRepeat')
  // const isPasswordRepeatDirty = formState.dirtyFields.passwordRepeat

  useEffect(() => {
    if (formState.errors.passwordRepeat && watchPassword === watchPasswordRepeat) {
      clearErrors('passwordRepeat')
    }
  }, [watchPassword, watchPasswordRepeat, formState.errors.passwordRepeat])

  useEffect(() => {
    if (formState.errors.emailRepeat && watchEmail === watchEmail_confirmation) {
      clearErrors('emailRepeat')
    }
  }, [watchEmail, watchEmail_confirmation, formState.errors.emailRepeat])

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(SignUpTranslation.form.title)}
      </OreHeading>
      <OreInput
        {...register('name')}
        {...errors('name')}
        id="name"
        label={t(SignUpTranslation.form.data.name.label)}
        placeholder={t(SignUpTranslation.form.data.name.placeholder)}
        required
        maxLength={20}
      />
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('surname1')}
          {...errors('surname1')}
          id="surname1"
          label={t(SignUpTranslation.form.data.surname1.label)}
          placeholder={t(SignUpTranslation.form.data.surname1.placeholder)}
          required
          maxLength={20}
        />
        <OreInput
          {...register('surname2')}
          {...errors('surname2')}
          id="surname2"
          label={t(SignUpTranslation.form.data.surname2.label)}
          placeholder={t(SignUpTranslation.form.data.surname2.placeholder)}
          maxLength={20}
        />
      </OreStack>
      <OreInput
        {...register('username')}
        {...errors('username')}
        id="username"
        label={t(SignUpTranslation.form.data.username.label)}
        placeholder={t(SignUpTranslation.form.data.username.placeholder)}
        required
        maxLength={50}
      />
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('email')}
          {...errors('email')}
          id="email"
          label={t(SignUpTranslation.form.data.email.label)}
          placeholder={t(SignUpTranslation.form.data.email.placeholder)}
          required
          maxLength={255}
        />
        <OreInput
          {...register('emailRepeat')}
          {...errors('emailRepeat')}
          id="emailRepeat"
          label={t(SignUpTranslation.form.data.repeatEmail.label)}
          type="email"
          placeholder={t(SignUpTranslation.form.data.repeatEmail.placeholder)}
          required
          maxLength={255}
        />
      </OreStack>
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('password')}
          {...errors('password')}
          id="password"
          label={t(SignUpTranslation.form.data.password.label)}
          type="password"
          placeholder={t(SignUpTranslation.form.data.password.placeholder)}
          legend={t(SignUpTranslation.form.data.password.legend)}
          maxLength={50}
          required
          onInput={() => {
            setValue('passwordRepeat', '')
            clearErrors('passwordRepeat')
          }}
        />
        <OreInput
          {...register('passwordRepeat')}
          {...errors('passwordRepeat')}
          id="passwordRepeat"
          label={t(SignUpTranslation.form.data.repeatPassword.label)}
          type="password"
          placeholder={t(SignUpTranslation.form.data.repeatPassword.placeholder)}
          maxLength={50}
          required
        />
      </OreStack>
      <OreCheckbox
        {...register('acceptConditions')}
        {...errors('acceptConditions')}
        label={
          <>
            {t(SignUpTranslation.form.data.acceptConditions.label)}{' '}
            <a
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              href={t(SignUpTranslation.form.data.acceptConditions.href)}
              target="_blank"
            >
              {t(SignUpTranslation.form.data.acceptConditions.link)}
            </a>
          </>
        }
        required
      />
    </OreStack>
  )
}
